<template>
    <div class="lg:h-screen">
        <perfect-scrollbar class="hidden lg:block lg:h-screen">
            <ul class="flex flex-col gap-10 px-5">
                <Track v-for="(track,index) in tracks" :key="index" :track="track" @click="selectTrack(index)" />
            </ul>
        </perfect-scrollbar>
        <Splide :options="{ rewind: true }" class="lg:hidden" data-splide='{"type":"loop","perPage":2}'>
            <SplideSlide v-for="(track,index) in tracks" :key="index">
                <Track :track="track" @click="selectTrack(index)" />
            </SplideSlide>
        </Splide>
    </div>
    <div class="w-11/12 lg:w-1/2 mx-auto flex justify-center items-center lg:min-h-screen">
        <div v-if="calculating">
            <h2 class="text-4xl lg:text-6xl font-bold">We are checking...</h2>
        </div>
        <div v-else>
            <div v-if="selected && !strategy" class="text-center">
                <img :src="selected.layout" class="mx-auto h-[130px] lg:h-auto">
                <h2 class="text-5xl lg:text-7xl font-black uppercase mb-8 mt-4">{{ selected.name }}</h2>

                <button class="uppercase mx-auto bg-red-800 text-lg lg:text-xl font-bold text-white px-6 py-2 rounded-sm" @click="calculateStrategy()">
                    Calculate strategy
                </button>
            </div>
            <div v-if="!selected">
                <p class="text-2xl lg:text-5xl text-center">
                    <span data-aos="fade" data-aos-duration="800" data-aos-delay="1000" class="text-lg lg:text-2xl text-green-600">
                        La Ferrari Strategia 9000 <small>v0.2</small>
                    </span><br><br>
                    <span data-aos="fade" data-aos-duration="800" data-aos-delay="2000" class="font-bold text-4xl lg:text-7xl text-red-600">
                        Ciao Frédéric!
                    </span>
                    <br>
                    <span data-aos="fade" data-aos-duration="800" data-aos-delay="3000">
                        Please choose a track.
                    </span>
                </p>
            </div>
            <div v-if="selected && strategy">
                <Strategy :strategy="strategy" :track="selected" />
                <div class="text-center my-4">
                    <button class="uppercase mx-auto bg-red-800 text-lg lg:text-xl font-bold text-white px-6 py-2 rounded-sm" @click="calculateStrategy()">
                    Recalculate
                    </button>
                </div>
                <img src="img/clowns.png" class="mx-auto">
            </div>
        </div>

    </div>
</template>

<script>
import Track from "./Track.vue";
import Strategy from "./Strategy.vue";
import { Splide, SplideSlide } from '@splidejs/vue-splide';

export default {
  name: "App",
  data() {
    return {
        strategy: false,
        calculating: false,
        selected: false,
        tyres: [
            {
                name: 'Soft',
                image: './img/tyres/soft.svg',
            },
            {
                name: 'Medium',
                image: './img/tyres/medium.svg',
            },
            {
                name: 'Hard',
                image: './img/tyres/hard.svg',
            },
            {
                name: 'Inter',
                image: './img/tyres/inter.svg',
            },
            {
                name: 'Wet',
                image: './img/tyres/wet.svg',
            },
        ],
        tracks: [
            {
                name: 'Bahrain',
                laps: 57,
                flag: '',
                layout: './img/tracks/bahrain.png',
            },
            {
                name: 'Jeddah',
                laps: 50,
                flag: '',
                layout: './img/tracks/jeddah.png',
            },
            {
                name: 'Albert Park',
                laps: 58,
                flag: '',
                layout: './img/tracks/melbourne.png',
            },
            {
                name: 'Imola',
                laps: 63,
                flag: '',
                layout: './img/tracks/imola.png',
            },
            {
                name: 'Miami',
                laps: 57,
                flag: '',
                layout: './img/tracks/miami.png',
            },
            {
                name: 'Barcelona',
                laps: 66,
                flag: '',
                layout: './img/tracks/barcelona.png',
            },
            {
                name: 'Monaco',
                laps: 78,
                flag: '',
                layout: './img/tracks/monaco.png',
            },
            {
                name: 'Baku',
                laps: 51,
                flag: '',
                layout: './img/tracks/baku.png',
            },
            {
                name: 'Montreal',
                laps: 70,
                flag: '',
                layout: './img/tracks/montreal.png',
            },
            {
                name: 'Red Bull Ring',
                laps: 71,
                flag: '',
                layout: './img/tracks/redbullring.png',
            },
            {
                name: 'Silverstone',
                laps: 52,
                flag: '',
                layout: './img/tracks/silverstone.png',
            },
            {
                name: 'Hungaroring',
                laps: 70,
                flag: '',
                layout: './img/tracks/hungaroring.png',
            },
            {
                name: 'Spa-Francorchamps',
                laps: 44,
                flag: '',
                layout: './img/tracks/spa.png',
            },
            {
                name: 'Zandvoort',
                laps: 72,
                flag: '',
                layout: './img/tracks/zandvoort.png',
            },
            {
                name: 'Monza',
                laps: 53,
                flag: '',
                layout: './img/tracks/monza.png',
            },
            {
                name: 'Singapore',
                laps: 61,
                flag: '',
                layout: './img/tracks/singapore.png',
            },
            {
                name: 'Suzuka',
                laps: 53,
                flag: '',
                layout: './img/tracks/suzuka.png',
            },
            {
                name: 'Qatar',
                laps: 57,
                flag: '',
                layout: './img/tracks/qatar.png',
            },
            {
                name: 'Circuit of the Americas',
                laps: 56,
                flag: '',
                layout: './img/tracks/cota.png',
            },
            {
                name: 'Mexico City',
                laps: 71,
                flag: '',
                layout: './img/tracks/mexico.png',
            },
            {
                name: 'Interlagos',
                laps: 71,
                flag: '',
                layout: './img/tracks/interlagos.png',
            },
            {
                name: 'Las Vegas',
                laps: 50,
                flag: '',
                layout: './img/tracks/lasvegas.png',
            },
            {
                name: 'Abu Dhabi',
                laps: 58,
                flag: '',
                layout: './img/tracks/abudhabi.png',
            }
        ]
    };
  },
  methods: {
    selectTrack: function(track) {
        this.selected = this.tracks[track];
        this.strategy = false;
    },
    getRandomTyre: function() {
        return this.tyres[ Math.floor( Math.random() * this.tyres.length ) ];
    },
    randomInteger: function(min,max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    shouldWeAddAnotherStint: function(stints, stintLaps) {
        if(stints.length >= 4) {
            return stints[ stints.length - 1 ].stintStart < stintLaps - 5;
        } else {
            return stints[ stints.length - 1 ].stintStart < stintLaps;
        }
    },
    calculateStrategy: function() {
        this.calculating = true;
        const minStints = 1;
        const startLap = 1;
        const maxStints = 6;

        let stints = [];

        let totalLaps = this.selected.laps;
        let stintLaps = totalLaps - minStints;

        stints.push({
            tyre: this.getRandomTyre(),
            stintStart: startLap,
        });

        // must do 2nd stint

        stints.push({
            tyre: this.getRandomTyre(),
            stintStart: this.randomInteger(startLap + 1, stintLaps),
        });


        while( this.shouldWeAddAnotherStint(stints, stintLaps) ) {
    
                stints.push({
                    tyre: this.getRandomTyre(),
                    stintStart: this.randomInteger(stints[ stints.length - 1 ].stintStart + 1, stintLaps),
                });

        }

        this.strategy = stints;

        setTimeout(function() {
            this.calculating = false;
        }.bind(this), 2000);
        
        
    },
  },
  components: {
    Track,
    Strategy,
    Splide,
    SplideSlide,
  },
};
</script>